import { render, staticRenderFns } from "./checkboxGroup.vue?vue&type=template&id=b892f354&scoped=true"
import script from "./checkboxGroup.vue?vue&type=script&lang=js"
export * from "./checkboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b892f354",
  null
  
)

export default component.exports